/* eslint-disable global-require */
// Installs global listeners that auto-reload once on a chunk load failure
// (stale deploy / rollout skew). Imported first so the listeners are registered
// before any dynamic import() runs.
import "./helpers/chunkReload";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-image-lightbox/style.css";
// import "react-circular-progressbar/dist/styles.css";
import "react-perfect-scrollbar/dist/css/styles.css";

import "./assets/css/vendor/bootstrap.min.css";
import "./assets/css/vendor/bootstrap.rtl.only.min.css";
import {
  defaultColor,
  isDarkSwitchActive,
  isMultiColorActive,
  themeColorStorageKey,
} from "./constants/defaultValues";
import { fetchSharedToken } from "./helpers/AuthApi";
// import "flag-icon-css/css/flag-icon.min.css";
// import "react-sliding-pane/dist/react-sliding-pane.css";
import "./tailwindBuild.css";

const color =
  (isMultiColorActive || isDarkSwitchActive) &&
  localStorage.getItem(themeColorStorageKey)
    ? localStorage.getItem(themeColorStorageKey)
    : defaultColor;

localStorage.setItem(themeColorStorageKey, color);

const render = () => {
  fetchSharedToken().finally(() => {
    import(`./assets/css/sass/themes/gogo.${color}.scss`).then(() => {
      require("./AppRenderer");
    });
  });
};

render();
